var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.438 17.749-5.22-5.215A.77.77 0 0 1 4 11.969q0-.346.219-.566l1.156-1.13a.7.7 0 0 1 .547-.252q.328 0 .578.251l3.5 3.519 7.5-7.54A.8.8 0 0 1 18.078 6q.328 0 .547.251l1.156 1.131a.77.77 0 0 1 .219.566q0 .345-.219.565l-9.218 9.236A.71.71 0 0 1 10 18a.71.71 0 0 1-.562-.251"
  })));
};
export default SvgCheck;